import { render, staticRenderFns } from "./DesignBq.vue?vue&type=template&id=7e48a7fe&scoped=true&"
import script from "./DesignBq.vue?vue&type=script&lang=js&"
export * from "./DesignBq.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=7e48a7fe&prod&scoped=true&lang=css&"
import style1 from "./DesignBq.vue?vue&type=style&index=1&id=7e48a7fe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e48a7fe",
  null
  
)

export default component.exports